// extracted by mini-css-extract-plugin
module.exports = {"introduction":"AlertsAssessment_introduction__3kWww","form":"AlertsAssessment_form__1LJCj","reportsTitle":"AlertsAssessment_reportsTitle__2evwm"};